<template>
  <div>
    <b-modal
      id="modal-role"
      ref="my-modal"
      cancel-variant="outline-secondary"
      ok-title="Save"
      :ok-disabled="user_type === 'super-admin'"
      cancel-title="Close"
      centered
      :title="$t('DEBTIA_FILE_CATEGORY')"
      size="sm"
      @ok="submitHandler"
    >
      <b-overlay
        id="overlay-background"
        :show="modalLoads === true"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-form>
          <validation-observer
            ref="fileCategoryForm"
            tag="form"
          >
            <b-row>
              <b-col
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_TITLE')"
                  label-for="title"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Title"
                    rules="required"
                  >
                    <b-form-input
                      id="title"
                      v-model="details.file_category"
                      type="text"
                      :placeholder="$t('DEBTIA_TITLE')"
                      :readonly="user_type === 'super-admin'"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </validation-observer>
        </b-form>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BOverlay,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import axios from '@axios'
import constants from '@/app-configs/constants'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
  },
  directives: {
    Ripple,
  },
  props: {
    getFileCategoriesData: {
      type: Object,
      required: true,
    },
    reloadMethod: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      modalLoads: false,
      snowOption: {
        theme: 'snow',
      },
      required,
      details: {},
      user_type: JSON.parse(localStorage.getItem('userData')).data.user_type,
    }
  },
  watch: {
    getFileCategoriesData: {
      handler() {
        this.details = { ...this.getFileCategoriesData }
      },
    },
  },
  methods: {
    submitHandler(evt) {
      evt.preventDefault()
      this.$refs.fileCategoryForm.validate().then(success => {
        if (success) {
          this.modalLoads = true
          let url = ''
          if (this.details.id > 0) {
            url = `${constants.baseUrl}/settings/edit-file-category`
          } else {
            url = `${constants.baseUrl}/settings/create-file-category`
          }
          axios.post(url, { ...this.details }).then(response => {
            if (response.status === 200) {
              this.$nextTick(() => {
                this.modalLoads = false
                this.$refs['my-modal'].toggle('#toggle-btn')
              })
              this.details = {
                id: 0, file_category: '', user_id: JSON.parse(localStorage.getItem('userData')).data.id,
              }
              this.reloadMethod()
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">

</style>
